import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { NEW_API_CONFIG } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * ブックマーク・後で見る一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BK/001', r).catch(handleError)
  } else {
    return newAxios.post('/BK/001', r).catch(handleError)
  }
}

/**
 * ブックマーク・後で見る一覧件数取得API
 * @param  {} params={}
 */
export const count = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BK/002', r).catch(handleError)
  } else {
    return newAxios.post('/BK/002', r).catch(handleError)
  }
}

/**
 * ブックマーク・後で見る追加API
 * @param  {} params={}
 */
export const add = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BK/003', r).catch(handleError)
  } else {
    return newAxios.post('/BK/003', r).catch(handleError)
  }
}

/**
 * ブックマーク・後で見る更新API
 * @param  {} params={}
 */
export const update = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BK/004', r).catch(handleError)
  } else {
    return newAxios.post('/BK/004', r).catch(handleError)
  }
}

/**
 * ブックマーク・後で見る削除API
 * @param  {} params={}
 */
export const remove = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BK/005', r).catch(handleError)
  } else {
    return newAxios.post('/BK/005', r).catch(handleError)
  }
}
